import './page-header.scss';

export interface PageHeaderProps {
    header: string;
    ingress?: string;
}

export const PageHeader = ({ header, ingress }: PageHeaderProps) => (
    <div className="page-header">
        <h1>{header}</h1>
        {ingress && <p className="page-header__ingress">{ingress}</p>}
    </div>
);
